module.exports = __webpack_public_path__ + "static/media/ljudls.641357ab.mp3";